module.exports = __webpack_public_path__ + "static/media/excel-shortcuts.e94ac966.png";